<template>
  <article>
    <div v-if="entradaIsEmpty">
      <i class="fa  fa-arrow-circle-right fa-lg" aria-hidden="true"></i>
    </div>
    <span v-else>{{ time.entrada }}</span>

    <span>-</span>

    <div v-if="saidaIsEmpty">
      <i class="fa  fa-arrow-circle-right fa-lg" aria-hidden="true"></i>
    </div>
    <span v-else>{{ time.saida }}</span>
  </article>
</template>

<script>
export default {
  props: {
    time: {
      type: Object
    }
  },
  computed: {
    entradaIsEmpty() {
      return this.time.entrada === ''
    },
    saidaIsEmpty() {
      return this.time.saida === ''
    }
  }
}
</script>

<style scoped>
article {
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
  align-items: center;
  padding: 0px 10px;
  margin-top: 5px;
}

div {
  width: 31px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/TimeCell.vue